import { z } from 'zod';
import { QuoteToolPreselectedModes } from '@lx/shared/utils/enums';

/**
 * Schema for representing the parameters of the Online Course deep links.
 * It is a Zod object schema where we define the required and optional parameters.
 * It is used to validate the parameters of the Online Course deep links.
 */
export const OnlineCourseDeepLinkParametersSchema = z
  .object({
    preselectedMode: z.enum(QuoteToolPreselectedModes),
    courseCode: z.string(),
    duration: z.number(),
    schoolCode: z.string(),
    classStartTime: z.string(),
    classEndTime: z.string(),
    deeplinkType: z.string(),
  })
  .partial()
  .required({
    preselectedMode: true,
    courseCode: true,
  });
